import { inject } from '@angular/core';
import { CanActivateFn, CanMatchFn, Router, UrlTree, UrlSegment } from '@angular/router';
import { ACCOUNT_URLS, AUTH_URLS } from '../app.routes.names';

const isAuthenticated = (): boolean => !!sessionStorage.getItem('auth_token');

const buildAttemptedUrl = (segments: UrlSegment[]): string =>
  '/' + segments.map((s) => s.path).join('/');

const redirectToLogin = (router: Router, attemptedUrl: string): UrlTree =>
  router.createUrlTree([AUTH_URLS.BASE, AUTH_URLS.LOGIN], {
    queryParams: { redirect: attemptedUrl }
  });

const redirectToAccount = (router: Router): UrlTree =>
  router.createUrlTree([ACCOUNT_URLS.BASE, ACCOUNT_URLS.SUMMARY]);

const requireAuth = (attemptedUrl: string, router: Router) =>
  isAuthenticated() ? true : redirectToLogin(router, attemptedUrl);

const requireGuest = (router: Router) =>
  isAuthenticated() ? redirectToAccount(router) : true;

// Runs after a route is matched but before it activates a component (protects loaded routes).
export const authCanActivate: CanActivateFn = (_route, state) => {
  const router = inject(Router);
  return requireAuth(state.url, router);
};

// Runs during route matching; prevents lazy modules from loading if unauthenticated.
export const authCanMatch: CanMatchFn = (_route, segments) => {
  const router = inject(Router);
  return requireAuth(buildAttemptedUrl(segments), router);
};

// Blocks auth pages for signed-in users; reroutes to account summary.
export const guestCanMatch: CanMatchFn = () => {
  const router = inject(Router);
  return requireGuest(router);
};

export const guestCanActivate: CanActivateFn = () => {
  const router = inject(Router);
  return requireGuest(router);
};
